import { render, staticRenderFns } from "./ArticlePublishNotificationContent.vue?vue&type=template&id=7307cba0&"
import script from "./ArticlePublishNotificationContent.vue?vue&type=script&lang=ts&"
export * from "./ArticlePublishNotificationContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports